import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import Error from "../features/Error.jsx";

import Button from "../components/Button/Button.jsx";
import ShimmerMultiLine from "../components/Shimmer/ShimmerMultiLine.jsx";

import DocumentList from "../features/CommonParts/Documents/DocumentList/DocumentList.jsx";
import { CONNECTION_STATUS } from "../utils/consts/connectionStatus";

import useDocuments from "../hooks/useDocuments.js";
import actions from "../store/actions";

import { apiAuthByPortal } from "../api/methods/auth.js";
import { apiChangeProcess } from "../api/methods/process.js";

import { apiFetchContractBillingIds } from "../api/methods/contract.js";
import { APP_ROUTES } from "../router";

const Documents = () => {
  const history = useNavigate();
  const dispatch = useDispatch();

  const {
    contract,
    setContract,
    signedDocuments,
    unsignedDocuments,
    hasError,
    setHasError,
    fetchDocumentsHome,
  } = useDocuments();

  const { mobileConnectionInfo } = useSelector(state => state);
  const [isFetchData, setIsFetchData] = useState(false);

  useEffect(() => {
    if (!mobileConnectionInfo.apiKey) {
      history(APP_ROUTES.MOBILE_CONNECTION.ROOT_ROUTE, { replace: true });
      return;
    }

    getDocumentList();
  }, []);

  const getDocumentList = async () => {
    try {
      setIsFetchData(true);
      const contractInfo = await apiFetchContractBillingIds(mobileConnectionInfo.apiKey);

      setContract(contractInfo);
      dispatch(actions.contract.changeContractInfo(contractInfo));

      await fetchDocumentsHome(contractInfo);
    } catch {
      setHasError(true);
    } finally {
      setIsFetchData(false);
    }
  };

  const goToNextStep = async () => {
    let response;

    try {
      response = await apiAuthByPortal(contract.contract_id, contract.billing_id);
    } finally {
      await apiChangeProcess(mobileConnectionInfo.apiKey, {
        has_auth: response?.status === CONNECTION_STATUS.AUTHORIZED,
      });

      history(APP_ROUTES.MOBILE_CONNECTION.FINISH_ROUTE, { replace: true });
    }
  };

  if (isFetchData) return <ShimmerMultiLine count={2} />;

  if (hasError || (![...signedDocuments, ...unsignedDocuments].length && !isFetchData)) {
    return <Error />;
  }

  return (
    <DocumentList
      unsignedDocuments={unsignedDocuments}
      signedDocuments={signedDocuments}
      contract={contract}
      getDocuments={fetchDocumentsHome}
    >
      <Button
        isStretch
        color="primary"
        size="xl"
        onClick={goToNextStep}
        disabled={unsignedDocuments.length > 0}
      >
        Далее
      </Button>
    </DocumentList>
  );
};

export default Documents;
